import * as React from "react";

import { ViewSelectorKey } from "./viewSelectorKey";

interface ViewSelectorListProps {
  children: (onClick: (key: ViewSelectorKey) => void) => React.ReactNode[];
  defaultActiveKey: ViewSelectorKey;

  onChange: (key: ViewSelectorKey) => void;
}

interface ViewSelectorListState {
  activeKey: ViewSelectorKey;
}

class ViewSelectorList extends React.PureComponent<ViewSelectorListProps, ViewSelectorListState> {
  constructor(props: ViewSelectorListProps) {
    super(props);

    this.state = {
      activeKey: this.props.defaultActiveKey,
    };
  }

  public render() {
    const children = this.props.children(this.handleClick);

    return (
      <section className="accuracy-details-selectors">
        <ul className="nav nav-tabs">
          {React.Children.map(children, (child) => {
            return (
              <li className="nav-item">
                {child}
              </li>
            );
          })}
        </ul>
      </section>
    );
  }

  private handleClick = (key: ViewSelectorKey) => {
    this.setState({ activeKey: key }, () => {
      this.props.onChange(this.state.activeKey);
    });
  }
}

export { ViewSelectorList };
